import { render, staticRenderFns } from "./piechart.vue?vue&type=template&id=114617dc&scoped=true"
import script from "./piechart.vue?vue&type=script&lang=js"
export * from "./piechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114617dc",
  null
  
)

export default component.exports